import { makeTextComponent } from './makeTextComponent'

export const SmallDetail = makeTextComponent(
  'shade-20 font-size-small font-family-system font-weight-regular margin-vertical-16 text-align-center'
)
